import { Component, Vue, Watch } from 'vue-property-decorator';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Modal } from 'bootstrap';
import { hideElementById } from '@/util/style-util';

@Component({
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class TermsOfUse extends Vue {
  isRegister = false;
  scrollSettings = {
    wheelPropagation: false,
  };

  language = this.$store.getters.currentLanguage || this.$store.getters.languages || 'en';

  mounted() {
    this.open();
  }

  open() {
    this.language = this.$store.getters.currentLanguage || this.$store.getters.languages || 'en';
    if (this.$route.name === 'TermsOfUse') {
      // @ts-ignore
      window.$('#termOfUseModal').modal('show');
    }
  }

  @Watch('$route')
  onRouteChange() {
    this.open();
  }

  scrollToSection(id) {
    document.getElementById(id).scrollIntoView();
  }

  handleConfirm() {
    this.$root.$emit('user-confirm-option', 'option1');
  }

  created() {
    this.language = this.$store.getters.currentLanguage || this.$store.getters.languages || 'en';
    this.$root.$on('register-action-readterm', this.setIsRegister);
    this.$root.$on('set-lang-action-readterm', this.language);
  }

  destroyed() {
    this.language = this.$store.getters.currentLanguage || this.$store.getters.languages || 'en';
    this.$root.$off('register-action-readterm', this.setIsRegister);
    this.$root.$off('set-lang-action-readterm', this.language);
  }

  setIsRegister() {
    this.isRegister = true;
  }

  handleCloseElement() {
    hideElementById('termOfUseModal', false);
  }
}
